export * from './delete-feld-kategorie.service';
export * from './delete-feld-kategorie.service.module';